import { defineStyleConfig } from '@chakra-ui/react';

// AlertDialog can reuse the Modal styles for consistency
const AlertDialog = defineStyleConfig({
  baseStyle: {
    dialog: {
      bg: 'gray.800',
      borderRadius: 'lg',
    },
    header: {
        fontWeight: 'bold',
        fontSize: 'xl',
    },
    closeButton: {
        _hover: {
            bg: 'gray.700'
        }
    }
  },
});

export default AlertDialog;
